module.exports = __webpack_public_path__ + "img/logo-mobility.f9de0e77.png";